import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { onboardingQuestionnaireActions } from '../../../../store';

import type { AppDispatch } from '../../../../store';

export default function useFetchOnboardingQuestionnaire() {
  const dispatch = useDispatch<AppDispatch>();
  const { onboardingQuestionnaireId } = useParams<'onboardingQuestionnaireId'>();
  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    if (!onboardingQuestionnaireId) return;

    dispatch(
      onboardingQuestionnaireActions.getOnboardingQuestionnaireById({
        onboardingQuestionnaireId,
        getAccessTokenSilently,
      }),
    );
  }, [dispatch, getAccessTokenSilently, onboardingQuestionnaireId]);
}
